export default __webpack_public_path__ + "static/media/hero-art.6a1a0db0.jpg";